import { render, staticRenderFns } from "./SidePanelConfigBoilerplate.vue?vue&type=template&id=3640d58c&scoped=true&"
import script from "./SidePanelConfigBoilerplate.vue?vue&type=script&lang=js&"
export * from "./SidePanelConfigBoilerplate.vue?vue&type=script&lang=js&"
import style0 from "./SidePanelConfigBoilerplate.vue?vue&type=style&index=0&id=3640d58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3640d58c",
  null
  
)

export default component.exports